const moveSound = require("@/assets/audio/move-self.mp3");
const captureSound = require("@/assets/audio/capture.mp3");
const endSound = require("@/assets/audio/game-end.mp3");

const SOUNDS = {
  move: moveSound,
  capture: captureSound,
  end: endSound,
};

export const playAudio = function(soundName) {
  const audio = new Audio(SOUNDS[soundName]);
  audio.addEventListener("canplaythrough", () => {
    /* the audio is now playable; play it if permissions allow */
    audio.play(); // the audio now can be played
  });
};
